import { IconComponentProps } from '@metservicedev/met-ui/icons';
import {
  IconNamesV1Union,
  Avalanche,
  BbqBad,
  BbqGood,
  BbqGoodish,
  Bbq,
  Cloud,
  FireDangerHigh,
  FireDangerLow,
  FireDangerModerate,
  FireDangerNone,
  FireDangerVeryhigh,
  FireSeason,
  FreezingLevel,
  Graph,
  Gust,
  LightningStrike,
  PollenRiskHigh,
  PollenRiskLow,
  PollenRiskModerate,
  Rain,
  Swimming,
  SwimmingRisk,
  Temperature,
  TrackWheelchair,
  TrackEasiest,
  TrackEasy,
  TrackIntermediate,
  TrackAdvanced,
  TrackExpert,
  Washing,
  Wind,
  WindChill,
  Loading,
  MoonFirstQuarter,
  WindSoutheastLight,
} from '@metservicedev/met-ui/icons-v1';
import React from 'react';

const IconsLegacyToV1Mapping: { [key: string]: IconNamesV1Union } = {
  avalanche: 'avalanche',
  'bbq-status-bad': 'bbq-bad',
  'bbq-status-good': 'bbq-good',
  'bbq-status-medium': 'bbq-goodish',
  'bbq-status-none': 'bbq',
  cloud: 'cloud',
  'condition-cloudy': 'cloud',
  'fenz-danger-high': 'fire-danger-high',
  'fenz-danger-low': 'fire-danger-low',
  'fenz-danger-moderate': 'fire-danger-moderate',
  'fenz-danger-na': 'fire-danger-none',
  'fenz-danger-veryHigh': 'fire-danger-veryhigh',
  'fenz-season-fire': 'fire-season',
  freezinglevel: 'freezing-level',
  graph: 'graph',
  'loading-logo': 'loading',
  'moon-first-quarter': 'moon-first-quarter',
  gust: 'gust',
  'person-drown-risk': 'swimming-risk',
  'pollen-level-high': 'pollen-risk-high',
  'pollen-level-low': 'pollen-risk-low',
  'pollen-level-medium': 'pollen-risk-moderate',
  rainfall: 'rain',
  swimming: 'swimming',
  'temp-general': 'temperature',
  tempgeneral: 'temperature',
  'walk-grade1': 'track-wheelchair',
  'walk-grade2': 'track-easiest',
  'walk-grade3': 'track-easy',
  'walk-grade4': 'track-intermediate',
  'walk-grade5': 'track-advanced',
  'walk-grade6': 'track-expert',
  'washing-index': 'washing',
  wind: 'wind',
  'wind-chill': 'wind-chill',
  'wind-southeast-light': 'wind-southeast-light',
  'warning-thunderstorm': 'lightning-strike',
};

export const icons: Partial<Record<IconNamesV1Union, ({ style, size, className }: IconComponentProps) => import('react/jsx-runtime').JSX.Element>> = {
  avalanche: Avalanche,
  'bbq-bad': BbqBad,
  'bbq-goodish': BbqGoodish,
  'bbq-good': BbqGood,
  bbq: Bbq,
  cloud: Cloud,
  'fire-danger-none': FireDangerNone,
  'fire-danger-low': FireDangerLow,
  'fire-danger-moderate': FireDangerModerate,
  'fire-danger-high': FireDangerHigh,
  'fire-danger-veryhigh': FireDangerVeryhigh,
  'fire-season': FireSeason,
  'freezing-level': FreezingLevel,
  graph: Graph,
  gust: Gust,
  'lightning-strike': LightningStrike,
  loading: Loading,
  'pollen-risk-high': PollenRiskHigh,
  'pollen-risk-low': PollenRiskLow,
  'pollen-risk-moderate': PollenRiskModerate,
  rain: Rain,
  'swimming-risk': SwimmingRisk,
  swimming: Swimming,
  temperature: Temperature,
  'track-wheelchair': TrackWheelchair,
  'track-easiest': TrackEasiest,
  'track-easy': TrackEasy,
  'track-intermediate': TrackIntermediate,
  'track-advanced': TrackAdvanced,
  'track-expert': TrackExpert,
  washing: Washing,
  wind: Wind,
  'wind-chill': WindChill,
  'moon-first-quarter': MoonFirstQuarter,
  'wind-southeast-light': WindSoutheastLight,
};

export const getIcon = (icon?: string) => {
  if (!icon) return Cloud;
  const iconName = IconsLegacyToV1Mapping[icon.toLowerCase()] ?? icon.toLowerCase();
  const iconComponent = icons[iconName as IconNamesV1Union];
  if (!iconComponent) {
    console.warn(`Icon "${icon}" not found`);
    return () => <div style={{ width: 32, height: 32 }} />;
  }
  return iconComponent;
};
